import type { IzQuestion } from './izteach.ts';
import type { ServerQuery } from './paging.ts';

/** The rows /question/admin drops for isFilterType (examination-service question/controller.js exceptTypes). */
const CHILD_TYPES = ['single-choice-child', 'multiple-choice-child', 'fill-blank-child', 'direct-fill-blank-child'];

function valueAt(row: IzQuestion, path: string): unknown {
  let value: unknown = row;
  path.split('.').forEach((part) => {
    value = value && typeof value === 'object' ? (value as Record<string, unknown>)[part] : undefined;
  });
  return value;
}

/**
 * Whether the server would return `row` for `query`, for the filter keys serverFilter sends.
 *
 * Mirrors izteach-core-service mongo-model standardQuery: `html_contain` is a case-insensitive $regex,
 * everything else equality (the schema casts '3' to 3). Any other operator throws, so a new facet
 * cannot quietly disagree with the server.
 */
export function matchesServerQuery(row: IzQuestion, query: ServerQuery): boolean {
  return Object.keys(query).every((key) => {
    const wanted = query[key];
    if (key === 'isFilterType') return !wanted || CHILD_TYPES.indexOf(row.type) === -1;
    if (key === 'html_contain') return new RegExp(String(wanted), 'i').test(row.html || '');
    if (key.indexOf('_') >= 0) throw new Error(`matchesServerQuery: ${key} is not a filter it can read`);
    const actual = valueAt(row, key);
    return actual !== undefined && actual !== null && String(actual) === String(wanted);
  });
}
